module.exports = __webpack_public_path__ + "static/circle-e8110c430e998661718d8fb33f7de6c7.png";